import { render, staticRenderFns } from "./JoinBuilder.vue?vue&type=template&id=56dd9efa"
import script from "./JoinBuilder.vue?vue&type=script&lang=js"
export * from "./JoinBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports